// Import packages
import React, {useEffect, useLayoutEffect, useState, useRef} from "react";
import Slider from "react-slick";

// Import styles
import "./image-modal.scss";

//Import Images
import {ArrowLeftIcon, ArrowRightIcon, ClearIcon, CloseModalIcon, ModalCloseIcon} from "../../../assets/images";
// Import components
import {Modal} from "antd";

//import utils
import {generateFileMediaUrl, generateFileMediaUrlWithoutDefault} from "../../../utils/generateMediaUrl";
import {Swiper, SwiperSlide} from "swiper/react";
import {FreeMode, Mousewheel, Navigation, Pagination, Thumbs} from "swiper/modules";
import 'swiper/css';
import 'swiper/css/pagination';
import {useInView} from "react-intersection-observer";

// import { InView } from "react-intersection-observer";

export function ImageModal(props) {
    const resetMovingOffset = 700
    const {closeModal, visible, modalImagePathList, modalCurrentImageIndex, isAbout} = props;
    const [showCloseIcon, setShowCloseIcon] = useState(false);
    const [mounted, setMounted] = useState(false);
    const [slideIndex, setSlideIndex] = useState(modalCurrentImageIndex);
    let sliderRef = useRef(null);
    let containerRef = useRef(null);
    let moveFromSlider = useRef(0);
    const [thumbsSwiper, setThumbsSwiper] = useState(null);

    useEffect(() => {
        document.documentElement.style.overflow = "hidden!important";
        document.body.style.overflow = "hidden!important";
        if (sliderRef.current) {
            // sliderRef.current.slickGoTo?.(modalCurrentImageIndex);
        }
        const element = document.getElementById('image_' + modalCurrentImageIndex);
        if (element) {
            const offset = 0;
            // const top = element.getBoundingClientRect().top + window.scrollY + offset;
            // containerRef.current.scrollTo({top});
            element.scrollIntoView({block: 'start'});
            setTimeout(() => {
                setMounted(true);
            }, 500)
        }
        return () => {
            document.documentElement.style.overflow = "";
            document.body.style.overflow = "";
        };
    }, []);

    useLayoutEffect(() => {
        if (visible) {
            sliderRef && sliderRef.current && sliderRef.current.slickGoTo(modalCurrentImageIndex);
            setTimeout(() => {
                setShowCloseIcon(true)
            }, 250)
        } else {
            setShowCloseIcon(false);
        }
    }, [visible]);

    useEffect(() => {
        let observer;
        if (modalImagePathList) {
            let observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting && !moveFromSlider.current) {
                            // setActiveImageIndex(entry.target.id);
                            const activeIndex = entry?.target?.id?.split("_")[1] || 0;
                            console.log("isIntersecting...", entry.target.id, activeIndex, moveFromSlider.current);
                            setSlideIndex(activeIndex)
                            if (sliderRef?.current) {
                                sliderRef.current.slickGoTo?.(activeIndex);
                            }
                        }
                    });
                },
                {threshold: 0.5}
            );

            modalImagePathList.forEach((_, index) => {
                const element = document.getElementById('image_' + index);
                if (element) observer.observe(element);
            });

        }

        return () => {
            if (modalImagePathList && observer) {
                modalImagePathList.forEach((_, index) => {
                    const element = document.getElementById('image_' + index);
                    if (element) observer.unobserve(element);
                });
            }
        };
    }, [modalImagePathList, sliderRef?.current]);

    const nextSlide = (index) => {
        console.log('nextSlide', slideIndex, index);
        if (Number(slideIndex) < modalImagePathList?.length - 1) {
            const newIndex = Number(slideIndex) + 1
            setSlideIndex(newIndex)
            sliderRef.current.slickNext();
            const element = document.getElementById('image_' + newIndex);
            if (element) {
                const tik = Date.now()
                moveFromSlider.current = tik
                const offset = 0;
                const top = element.getBoundingClientRect().top + window.scrollY + offset;
                // containerRef.current.scrollTo({top,});
                // containerRef.current.scrollTo({top, behavior: 'smooth'});
                element.scrollIntoView({block: 'start', behavior: 'smooth'});
                setTimeout(resetMoving, resetMovingOffset, tik)
            }
        }
    };

    const prevSlide = (index) => {
        console.log('prevSlide', slideIndex, index);

        const newIndex = Number(slideIndex) === 0 ? 0 : slideIndex - 1

        setSlideIndex(newIndex)
        const element = document.getElementById('image_' + newIndex);
        if (element) {
            const tik = Date.now()
            moveFromSlider.current = tik
            const offset = 0;
            const top = element.getBoundingClientRect().top + window.scrollY + offset;
            // containerRef.current.scrollTo({top, behavior: 'smooth'});
            element.scrollIntoView({block: 'start', behavior: 'smooth'});
            setTimeout(resetMoving, resetMovingOffset, tik)
        }
        sliderRef.current.slickPrev();
    };

    const goToSlide = (index) => {
        console.log('goToSlide', slideIndex, index);
        setSlideIndex(index)
        const element = document.getElementById('image_' + index);

        sliderRef.current.slickGoTo?.(index);
        if (element) {
            const tik = Date.now()
            moveFromSlider.current = tik
            const offset = 0;
            const top = element.getBoundingClientRect().top + window.scrollY + offset;
            // containerRef.current.scrollTo({top, behavior: 'smooth'});
            element.scrollIntoView({block: 'start', behavior: 'smooth'});
            setTimeout(resetMoving, resetMovingOffset, tik)
        }
    };

    function resetMoving(date) {
        console.log('resetMoving', date, moveFromSlider.current)
        if (moveFromSlider.current && date == moveFromSlider.current) {
            moveFromSlider.current = 0
        }
    }

    const settings = {
        dots: false,
        arrows: false,
        ref: slider => (sliderRef.current = slider),
        // swipeToSlide: false,
        focusOnSelect: false,
        vertical: true,
        verticalSwiping: true,
        infinite: false,
        slidesToScroll: 1,
        slidesToShow: 6,
        afterChange: (index) => {
            console.log('afterChange', index)
        },
        responsive: [
            {
                breakpoint: 1050,
                settings: {
                    vertical: false,
                    verticalSwiping: false,
                    slidesToShow: 4,
                }
            },
        ]
    };

    // console.log('modalImagePathList', modalImagePathList)
    // console.log('modalCurrentImageIndex', modalCurrentImageIndex)
    console.log('slideIndex', slideIndex)
    return <Modal
        visible={visible}
        wrapClassName={'custom-modal'}
        closeIcon={<ModalCloseIcon/>}
        onCancel={props.closeModal}>
        <div className={'Img-modal-wrapper'}>
            <button className={`modal-closing-btn ${showCloseIcon ? 'show' : ''}`}
                    onClick={closeModal}>
                <ModalCloseIcon title={''}/>
            </button>
            {!!modalImagePathList?.length &&
                <div className="images-block">
                    <div className="images-wrapper" ref={containerRef}>
                        {
                            modalImagePathList?.map((path, index) => {
                                return (
                                    <div className="img-content" key={path} id={'image_' + index}>
                                        <img src={generateFileMediaUrlWithoutDefault(path)}
                                             className={'img-block'} alt={"about"}/>
                                    </div>
                                )
                            })
                        }
                    </div>

                    <div className="images-list-block">
                        {!!modalImagePathList?.length && <Slider {...settings}>
                            {modalImagePathList?.map((path, index) => {
                                return <div key={path}
                                            className={`list-img-item ${(slideIndex == index) ? 'active-img' : ''}`}>
                                    <img src={generateFileMediaUrlWithoutDefault(path)} className={'list-img'}
                                         onClick={() => goToSlide(index)} alt={"about"}/>
                                </div>
                            })}
                        </Slider>}
                        {modalImagePathList?.length > 5 &&
                            <>
                                <button className={`slider-btn  prev-btn`}
                                        onClick={() => prevSlide(slideIndex)}
                                        disabled={slideIndex === 0}
                                >
                                    {'<'}
                                </button>
                                <button
                                    className={`slider-btn next-btn`}
                                    disabled={slideIndex === modalImagePathList?.length - 1}
                                    onClick={() => nextSlide(slideIndex)}>
                                    >
                                </button>
                            </>
                        }
                    </div>
                </div>
            }
        </div>
    </Modal>
}
